import React, { useState, useEffect } from "react"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import UserEditTabs from "./useredit.component"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import PreferenceService from "../state/user/PreferenceService"
import { isError } from "../state/helpers/Error"
import Preference from "../state/user/Preference"
import SignatureSettings from "../state/user/SignatureSettings"
import SideBar from "../common/layout/sidebar.component"
import RichTextEditor from "../common/rich-text/editor.component.jsx"
import ImageUploaderDropZone from "../common/image-uploader/dropzone.component"
import Toggle from "react-toggle"
import { Intl } from "../state/helpers/IntlProps"
import { match } from "react-router"
import { ImageDto } from "../state/pricing/Image"

const messages = defineMessages({
    "submitConfirmed": {
        id: "user.signature_settings_component.submit-confirmed",
        defaultMessage: "Success"
    },
})

interface Identifiable {
    userId: string
}

type Props = {
    match: match<Identifiable>
    intl: Intl
}

type images = {
    image: ImageDto[],
    isLoaded: boolean
}

const SignatureSettingsComponent = (props: Props) => {

    const [signatureLogoId, setSignatureLogoId] = useState("")
    const [signature, setSignature] = useState("")
    const [isEnable, setIsEnable] = useState(false)
    const [imageUrl, setImageUrl] = useState("")
    const [images, setImages] = useState<images>({image: [], isLoaded: false})
    const [errorMessage, setErrorMessage] = useState("")
    const [buttonState, setButtonState] = useState("")
    const userId = props.match.params.userId


    useEffect(() => {
        SideBar.activateMenu("account")
        retrieveSignature()
    }, [])

    const updateSignature = async () => {
        const payload = {
            signatureLogoId: signatureLogoId,
            logoUrl: imageUrl,
            signature: signature,
            isEnable: isEnable
        } as SignatureSettings

        PreferenceService.UpdateSignaturePreference(payload, userId).then(res => {
            if (isError(res)) {
                retrieveSignature()
                setErrorMessage(res.message)
            } else {
                setButtonState(props.intl.formatMessage(messages["submitConfirmed"]))
            }
        })
    }

    const retrieveSignature = async () => {
        const res = await PreferenceService.get(userId)
        let imagesToSet: ImageDto[] = []
        if (!isError(res)) {
            if (Object.keys(res).length > 0) {
                const preference = res as Preference
                setIsEnable(preference.getSignatureIsEnable())
                setSignatureLogoId(preference.getSignatureLogoId())
                setSignature(preference.getSignature())
                setImageUrl(preference.getSignatureLogoUrl())
                if (preference.getSignatureLogoId()) {
                    const img = await AppContext.getApiClient().get(`/images/${preference.getSignatureLogoId()}`)
                    imagesToSet = [img]
                }
            }
        } else {
            setErrorMessage(res.message)
        }
        setImages({image: imagesToSet, isLoaded: true})
    }

    const handleImageChange = (images) => {
        if (images.length > 0) {
            setImages({image: images, isLoaded: true})
            setSignatureLogoId(images[0].id)
            setImageUrl(images[0].attributes.publicUrl)
        } else {
            setImages({image: [], isLoaded: true})
            setSignatureLogoId("")
            setImageUrl("")
        }
    }

    return (
        <>
            <UserEditTabs userId={userId}/>
            {images.isLoaded &&
                <>
                    <div className="row ui-has-modules">
                        <div className="col-8">
                            <h2 className="m-0 custom-lead">
                                <FormattedMessage
                                    id="user.signature_settings_component.signature-settings"
                                    defaultMessage="Signature"
                                />
                            </h2>
                        </div>
                    </div>
                    <div className="row px-3">
                        <div className="col-12">
                            <div className="row ui-has-modules">
                                <div className="col-12 ui-module">

                                    <div className="mb-1 row">
                                        <label className="col-2 col-form-label custom-form-label strong">
                                            <FormattedMessage
                                                id="user.signature_settings_component.signature-settings-logo"
                                                defaultMessage="Logo"
                                            />
                                        </label>
                                        <div className="col-10">
                                            <ImageUploaderDropZone
                                                onUpdateImageList={handleImageChange}
                                                maxFiles={1}
                                                showFiletypeIcon={signatureLogoId ? false : true}
                                                images={images.image}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-1 row">
                                        <label className="col-2 col-form-label custom-form-label strong">
                                            <FormattedMessage
                                                id="user.signature_settings_component.signature-settings-signature"
                                                defaultMessage="Signature"
                                            />
                                        </label>
                                        <div className="col-10">
                                            <RichTextEditor
                                                height={300}
                                                name="content"
                                                value={signature}
                                                onChange={(sig) => {
                                                    setSignature(sig)
                                                }}
                                                id="content"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <label className="col-2 col-form-label custom-form-label strong">
                                            <FormattedMessage
                                                id="user.signature_settings_component.signature-settings-enable"
                                                defaultMessage="Enable"
                                            />
                                        </label>
                                        <div className="col-10">
                                            <Toggle
                                                checked={isEnable}
                                                onChange={() => {
                                                    setButtonState(""),
                                                    setIsEnable(!isEnable)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6 text-align-left" style={{
                                color: "blue",
                                padding: "8px",
                                paddingLeft: "20px"
                            }}>
                                {errorMessage}
                                {buttonState}
                            </div>
                            <div className="col-6 text-align-right">
                                <input
                                    type="submit"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        updateSignature()
                                    }}/>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>

    )
}

export default injectIntl(SignatureSettingsComponent)


// WEBPACK FOOTER //
// ./src/user/SignatureSettingsComponent.tsx